module.exports = __webpack_public_path__ + "media/icons/naped-tyl-unactive@3x-3eacbd01.svg";